import React, {useEffect, useRef, useState} from 'react';
import useSuccessManager from 'components/SuccessManager/useSuccessManager';
import SuccessManagerAvatar from 'components/SuccessManager/SuccessManagerAvatar';
import {IconCopy, IconMail} from 'components/SuccessManager/icons';
import {
  SUCCESS_MANAGER_SOURCES,
  copyEmail,
  getFullName,
  getMailto,
  trackEmailClicked
} from 'components/SuccessManager/helpers';
import {
  SuccessManagerActions,
  SuccessManagerCopyButton,
  SuccessManagerEmailButton,
  SuccessManagerEyebrow,
  SuccessManagerHelpCard as Card,
  SuccessManagerHelpInfo,
  SuccessManagerName,
  SuccessManagerText
} from 'components/SuccessManager/styles';

const COPIED_LABEL_MS = 1500;

// Full-width card on top of the Help page; hidden when the location has no CSM.
const SuccessManagerHelpCard = () => {
  const manager = useSuccessManager();
  const [copied, setCopied] = useState(false);
  const copiedTimer = useRef(null);

  useEffect(() => () => clearTimeout(copiedTimer.current), []);

  if (!manager) return null;

  const firstName = manager.firstName || getFullName(manager);

  const handleCopy = async () => {
    if (!(await copyEmail(manager, SUCCESS_MANAGER_SOURCES.HELP_PAGE))) return;
    setCopied(true);
    clearTimeout(copiedTimer.current);
    copiedTimer.current = setTimeout(() => setCopied(false), COPIED_LABEL_MS);
  };

  return (
    <Card aria-label='Your Customer Success Manager'>
      <SuccessManagerAvatar manager={manager} variant='help' />
      <SuccessManagerHelpInfo>
        <SuccessManagerEyebrow>
          Your dedicated customer success manager
        </SuccessManagerEyebrow>
        <SuccessManagerName>{getFullName(manager)}</SuccessManagerName>
        <SuccessManagerText>
          {firstName} is your go-to person for growing your restaurant. Reach
          out for help with setup, getting more direct orders, or any questions
          about your account.
        </SuccessManagerText>
      </SuccessManagerHelpInfo>
      <SuccessManagerActions>
        <SuccessManagerEmailButton
          as='a'
          className='ButtonMedium solid'
          href={getMailto(manager)}
          onClick={() => trackEmailClicked(SUCCESS_MANAGER_SOURCES.HELP_PAGE)}
        >
          <span>
            <IconMail />
            Email {firstName}
          </span>
        </SuccessManagerEmailButton>
        <SuccessManagerCopyButton type='button' onClick={handleCopy}>
          <IconCopy />
          {copied ? 'Copied' : 'Copy email'}
        </SuccessManagerCopyButton>
      </SuccessManagerActions>
    </Card>
  );
};

export default SuccessManagerHelpCard;
